class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      
      const cartItems =
        this.closest('cart-items') || this.closest('cart-drawer-items');

        // Find the batch class of the clicked item
      const batchClass = this.closest('.cart-item').classList.value
      .split(' ')
      .find((cls) => cls.startsWith('batch-add-'));
      
      if (batchClass) {
        const batchId = batchClass.match(/batch-add-(\d+)/)[1];
        let updates = {}
        // Remove all items with the same batch class
        const itemsToRemove = document.querySelectorAll(`.cart-item.batch-add-${batchId}`);
        itemsToRemove.forEach(item => {
          const variantId = item.getAttribute('batch-data-variant-id');
          updates[variantId] = 0;
        });
        
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        })
        .then(async(response) => {
          const res = await fetch("/cart.js")
          const cartRes = await res.json()
          const cartResponse = await fetch("", {
            method: 'GET',
            headers: {
                'Content-Type': 'text/html',
                'Accept': 'text/html'
            }
        });

        if (!cartResponse.ok) {
            throw new Error('Error fetching cart');
        }

        const html = await cartResponse.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCartDrawer = doc.querySelector(".drawer__inner");
        const newCartBubble = doc.querySelector('#cart-icon-bubble');
        const new_desktop_cartBubble = doc.querySelector('#desktop-cart-icon-bubble');
        const cartDrawer = document.querySelector(".drawer__inner");
        const cartBubble = document.querySelector("#cart-icon-bubble");
        const desktop_cartBubble = document.querySelector('#desktop-cart-icon-bubble');
        const new_cart_items_wrapper = doc.querySelector(".cart-page-main-cart-items");
        const cart_items_wrapper = document.querySelector(".cart-page-main-cart-items");
        const new_cart__footer = doc.querySelector(".cart__footer-wrapper");
        const cart__footer = document.querySelector(".cart__footer-wrapper");
        if (cartDrawer && newCartDrawer) {
            cartDrawer.innerHTML = newCartDrawer.innerHTML;
            if ( cartRes.item_count === 0 ) {
                
                document.querySelector(".drawer").classList.add("is-empty");
              
            }
        }
        if (cartBubble && newCartBubble) {
            cartBubble.innerHTML = newCartBubble.innerHTML;
        }
        if (desktop_cartBubble && new_desktop_cartBubble) {
            desktop_cartBubble.innerHTML = new_desktop_cartBubble.innerHTML;
        }
        if (cart_items_wrapper && new_cart_items_wrapper) {
          cart_items_wrapper.innerHTML = new_cart_items_wrapper.innerHTML;
        }
        if (cart__footer && new_cart__footer) {
          cart__footer.innerHTML = new_cart__footer.innerHTML;
        }
      })
        .catch((error) => {
          console.error('Error:', error);
        });
      } else {
        // Default behavior: Remove single product
        cartItems.updateQuantity(this.dataset.index, 0);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);


class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = "";

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace(
        "[min]",
        event.target.dataset.min
      );
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace(
        "[max]",
        event.target.max
      );
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace(
        "[step]",
        event.target.step
      );
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  drawerHeightAdjuster() {
    const promoBannerWrapper = document.querySelector(".promo-banner-wrapper");
    const updateDrawerClasses = (hasPromo, scroll) => {
      const drawerInner = document.querySelector(".drawer__inner");
      drawerInner.classList.remove("drawer__inner__with_promo");
      drawerInner.classList.toggle(
        "drawer__inner__without_promo",
        !hasPromo || scroll > 10
      );
      drawerInner.classList.remove("height_with_promo");
      drawerInner.classList.toggle(
        "height_without_promo",
        !hasPromo || scroll > 10
      );
    };

    updateDrawerClasses(!!promoBannerWrapper, window.scrollY);
  }

  onCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );

          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          this.drawerHeightAdjuster();
          // rerendering the desktop header cart icon
          fetch(`${window.location.href}`)
            .then((res) => {
              return res.text();
            })
            .then((res) => {
              const html = new DOMParser().parseFromString(res, "text/html");
              const new_desktop_cartBubble = html.querySelector(
                "#desktop-cart-icon-bubble"
              );
              const desktop_cartBubble = document.querySelector(
                "#desktop-cart-icon-bubble"
              );
              if (desktop_cartBubble && new_desktop_cartBubble) {
                desktop_cartBubble.innerHTML = new_desktop_cartBubble.innerHTML;
              }
            });
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }
  getSectionsToRender() {
    const cartDrawerFreeSamples = document.getElementById(
      "cart-drawer-free-samples"
    );
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-page-item-count",
        section: document.getElementById("cart-page-item-count").dataset.id,
        selector: ".cart-page-item-count",
      },
      {
        id: "cart-page-free-gift-slider-mobile",
        section: document.getElementById("cart-page-free-gift-slider-mobile")
          .dataset.id,
        selector: ".cart-page-free-gift-slider",
      },
      {
        id: "cart-page-free-gift-slider-desktop",
        section: document.getElementById("cart-page-free-gift-slider-desktop")
          .dataset.id,
        selector: ".cart-page-free-gift-slider",
      },
      {
        id: "cart-page-free-gifts",
        section: document.getElementById("cart-page-free-gifts").dataset.id,
        selector: ".cart-page__free_gifts",
      },
      {
        id: "cart-drawer-free-gifts",
        section: document.getElementById("cart-drawer-free-gifts").dataset.id,
        selector: ".cart-drawer__free_gifts",
      },
      {
        id: "cart-drawer-free-samples",
        section: cartDrawerFreeSamples
          ? cartDrawerFreeSamples.dataset.id
          : null,
        selector: ".cart-drawer__free_samples",
      },
    ];
  }

  async updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then(async (response) => {
        document.dispatchEvent(new Event("cart:updated"));
        const cartResponse = await fetch("", {
          method: "GET",
          headers: {
            "Content-Type": "text/html",
            Accept: "text/html",
          },
        });

        if (!cartResponse.ok) {
          throw new Error("Error fetching cart");
        }

        const html = await cartResponse.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const new_desktop_cartBubble = doc.querySelector(
          "#desktop-cart-icon-bubble"
        );
        const desktop_cartBubble = document.querySelector(
          "#desktop-cart-icon-bubble"
        );
        const free_shipping_banner = document.querySelectorAll(
          ".free-shipping__text"
        );
        const new_free_shipping_banner = doc.querySelectorAll(
          ".free-shipping__text"
        );
        const free_shipping_banner_style =
          document.querySelectorAll(".free-shipping");
        const res = await fetch("/cart.js");
        const cartRes = await res.json();
        if (
          free_shipping_banner &&
          new_free_shipping_banner &&
          cartRes.items.length > 1
        ) {
          free_shipping_banner.forEach((banner, index) => {
            banner.innerHTML = new_free_shipping_banner[index].innerHTML;
          });
        } else if (
          free_shipping_banner &&
          new_free_shipping_banner &&
          cartRes.items.length === 1 &&
          cartRes.items[0].quantity >= 1
        ) {
          free_shipping_banner.forEach((banner, index) => {
            banner.innerHTML = new_free_shipping_banner[index].innerHTML;
          });
        } else if (
          free_shipping_banner &&
          new_free_shipping_banner &&
          cartRes.items.length === 0
        ) {
          free_shipping_banner_style.forEach((banner) => {
            banner.style.display = "none";
          });
        }
        if (desktop_cartBubble && new_desktop_cartBubble) {
          desktop_cartBubble.innerHTML = new_desktop_cartBubble.innerHTML;
        }
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        // errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.querySelectorAll(`#Line-item-error-${line}`);
    const cartDrawerLineItemError = document.querySelectorAll(
      `#CartDrawer-LineItemError-${line}`
    );
    if (lineItemError) {
      lineItemError.forEach((error) => {
        error.querySelector(".cart-item__error-text").textContent = message;
      });
    }

    if (cartDrawerLineItemError) {
      cartDrawerLineItemError.forEach((error) => {
        error.querySelector(".cart-item__error-text").textContent = message;
      });
    }

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
